export const enClientPortalAssetKeyValues = {
    basedOn: 'Key figures are based on {{source}} dated {{date}}',
    basedOnSources: {
        draft: 'the draft',
        importedDraft: 'the imported draft',
        valuation: 'the valuation',
        importedValuation: 'the imported valuation',
    },
    marketValueDevelopmentTitle: 'Market value development',
    rentAndCostsDevelopmentTitle: 'Rent and cost development',
    chart: {
        yearFilterUnitLabel: 'Y',
    },
    chartSeries: {
        managementCosts: 'Management costs',
        maintenanceCosts: 'Maintenance costs',
        administrativeCosts: 'Administrative costs',
        lossOfRentRisk: 'Loss-of-rent risk',
    },
    assetLocation: {},
    energyEfficiency: {},
    noValuationInfo: {
        description: 'No data from completed valuations is available for this asset yet.',
        viewOrder: 'View order',
        createOrder: 'Create new order',
    },
    allValues: {
        sections: {
            mortgageLendingValueResults: 'Mortgage lending value results',
            yields: 'Yields',
            relevantArea: 'Valuation-relevant areas',
        },
        year: 'year',
        years: 'years',
    },
}
